export const featureRequestKeys = {
  all: ["feature-requests"] as const,
  list: () => [...featureRequestKeys.all, "list"] as const,
  comments: (requestId: string) => [...featureRequestKeys.all, "comments", requestId] as const,
  attachments: (requestId: string) =>
    [...featureRequestKeys.all, "attachments", requestId] as const,
};
